import { po_columns } from "../../Pages/HomePage/components/PoTable/helper/po_columns";
import PO_DATA from "../../Pages/HomePage/components/PoTable/helper/po_creator";
import getErrorMessage from "../../util";
import { PO_EDIT_DATA_FAILURE, PO_EDIT_DATA_SUCCESS, PO_LOAD_FAILURE, PO_LOAD_START, PO_LOAD_SUCCESS, PO_SINGLE_UPLOAD_SUCCESS } from "./po.types";
import { v4 } from "uuid";
import { PO_Backlog_Service } from "./po_backlog.services";
import { convert_date_to_dd_mm_yyyy } from "../../Pages/HomePage/components/BacklogTable/utils/util";
import { po_table_headers } from "../../Pages/HomePage/components/PoTable/helper/po_table_format";

const update_data_in_local_storage = (table_data, columns) => {
  localStorage.setItem("po_table_data", JSON.stringify(table_data));
  localStorage.setItem("po_columns", JSON.stringify(columns));
};

const po_load_start_action = () => ({
  type: PO_LOAD_START
});

const po_upload_success_action = (payload) => ({
  type: PO_LOAD_SUCCESS,
  payload
});

const po_upload_failure_action = (payload) => ({
  type: PO_LOAD_FAILURE,
  payload
});

const po_load_success_action = (payload) => ({
  type: PO_LOAD_SUCCESS,
  payload
});

const po_load_failure_action = (payload) => ({
  type: PO_LOAD_FAILURE,
  payload
});

export const load_po_from_backend = (state) => async (dispatch) => {
  // console.log("loading po from backend");
  dispatch(po_load_start_action());
  try {
    const sample_types_response = await PO_Backlog_Service.sample_types_get();
    const result_sample_types = sample_types_response.data;
    if (result_sample_types?.data && Array.isArray(result_sample_types?.data)) {
      const sample_types = result_sample_types?.data;
      const payload = {};
      const columns = Object.values(po_table_headers).map((property) => ({
        ...property
      }));
      for (let sample_type of sample_types) {
        const response = await PO_Backlog_Service.po_data_get_with_category({ category: sample_type });
        const result = response.data;
        const table_data = result.data.map((item => ({ ...item, id: v4() })));
        payload[sample_type] = {
          table_data,
          status: true,
          columns
        };
      }
      setTimeout(() => {
        dispatch(po_load_success_action(payload));
      }, 1500);
    }
    else if (result_sample_types?.data && typeof (result_sample_types?.data) === "object") {
      const major_categories = Object.keys(result_sample_types.data);
      const payload = {
        sample_types: major_categories
      };
      const columns = Object.values(po_table_headers).map((property) => ({
        ...property
      }));
      for (let sample_type of major_categories) {
        const response = await PO_Backlog_Service.po_data_get_with_category({ category: sample_type });
        const result = response.data;
        const table_data = result.data.map((item => ({ ...item, id: v4() })));
        payload[sample_type] = {
          table_data,
          status: true,
          columns
        };
      }
      setTimeout(() => {
        dispatch(po_load_success_action(payload));
      }, 1500);
    }
  } catch (error) {
    const err = getErrorMessage(error);
    dispatch(po_load_failure_action(err));
  }
};

const po_single_upload_success_action = (payload) => ({
  type: PO_SINGLE_UPLOAD_SUCCESS,
  payload
});

const calculate_progress = (progress, total) => ({
  completed: progress,
  remaining: total - progress,
  total: total,
  progress: Math.round((progress / total) * 100),
});

export const handle_po_upload = (jsonData, file) => async (dispatch) => {
  dispatch(po_load_start_action());
  try {
    // Convert to array of objects
    const headers = jsonData[0];
    headers.push("expected_delivery_date_by_ip_qa");
    headers.push("receiving_date_by_qc");
    const validation =
      // file_validator(selected_plant, key_to_be_updated, headers) 
      { isValid: true }
      ;
    console.log({ validation });
    if (!validation.isValid) {
      // set_open_snackbar_with_message({
      //   message: `Uploaded file is missing the required column(s): \n${validation?.missing_keys.join(", ")}`,
      //   open: true,
      //   severity: "error"
      // });
      return;
    }
    const rows = jsonData.slice(1);
    // rows.forEach((row) => {
    //   if (row) {
    //     PO_DATA(row);
    //   }
    // });
    const formattedData = rows.filter(row => row.length > 0).map((row) => {
      const obj = {};
      headers.forEach((header, index) => {
        obj[header.trim().split(" ").join("_").toLowerCase()] = row[index];
      });
      obj.id = v4();
      return obj;
    });
    console.log(formattedData);
    const po_data = [];
    formattedData.forEach((data) => {
      if (data) {
        po_data.push(new PO_DATA(data));
      }
    });
    console.log({ po_data });
    let progress = 0;
    let length = po_data.length;
    for (let i = 0; i < length; i++) {
      try {
        // console.log('will upload :', po_data[0]);
        const upload_response = await PO_Backlog_Service.po_data_post(po_data[i]);
        const data = upload_response.data;
        console.log("response received after uploading : ", { data });
        progress++;
        console.log({ percent: ((progress) * 100 / length) });
        const upload_progress = calculate_progress(progress, length);
        dispatch(po_single_upload_success_action(upload_progress));
      } catch (error) {
        const err = getErrorMessage(error);
        if (err === "Request failed with status code 400") {
          console.log("increasing progress as data is already present...");
          progress++;
          const upload_progress = calculate_progress(progress, length);
          dispatch(po_single_upload_success_action(upload_progress));
          console.log({ percent: ((progress) * 100 / length) });
        }
        else {
          console.log(`error occured while uploading data`, { err });
        }
      }
    }
    console.log({ headers });
    // const columns = headers.filter(header => header !== "id").map((header) => ({
    //   field: header.split(" ").join("_").toLowerCase(),
    //   headerName: header.split("_").join(" ").toUpperCase(),
    //   editable: true
    // }));
    // columns[columns.length - 3].hide = true;
    // columns[columns.length - 2].type = "dateTime";
    // columns[columns.length - 2].width = 300;
    // columns[columns.length - 1].type = "dateTime";
    // columns[columns.length - 1].width = 300;
    const columns = Object.keys(po_columns).map((key_name) => ({
      field: key_name,
      headerName: key_name.split("_").join(" ").toUpperCase(),
      editable: true
    }));
    // columns[columns.length - 1].renderCell = (params) => (
    //   <DateTimePicker
    //     minDateTime={new Date()}
    //   />
    // );
    console.log({ columns });
    // columns.push({ field: "id" });
    const table_data = po_data;
    update_data_in_local_storage(table_data, columns);
    console.log({ table_data });
    const payload = {
      file: file,
      columns,
      table_data,
      status: true,
    };
    dispatch(po_upload_success_action(payload));
  } catch (error) {
    const err = getErrorMessage(error);
    console.log({ err });
    dispatch(po_upload_failure_action(err));
  }
};

const po_edit_success_action = (payload) => ({
  type: PO_EDIT_DATA_SUCCESS,
  payload
});

const po_edit_failure_action = (payload) => ({
  type: PO_EDIT_DATA_FAILURE,
  payload
});

export const handle_po_data_update = (selected_data, state, key_name, value) => async (dispatch) => {
  dispatch(po_load_start_action());
  try {
    const { order } = selected_data;
    console.log({ value, order });
    // const temp = { ...state };
    // const temp_arr = JSON.parse(JSON.stringify(state.po.table_data)).map((data) => {
    //   if (data.order === selected_data.order) {
    //     const new_data = new PO_DATA({
    //       ...data,
    //       [key_name]: value
    //       // []
    //     });
    //     return new_data;
    //   }
    //   return data;
    // });
    // temp.po.table_data = [...temp_arr];
    const payload = {
      // ...temp.po,
    };
    try {
      const patch_body = {
        order,
        [key_name]: value
      };
      const response = await PO_Backlog_Service.po_data_patch(patch_body);
      const result = response.data;
      if (result.data) {
        dispatch(po_edit_success_action(payload));
      }
    } catch (error) {
      const err = getErrorMessage(error);
      dispatch(po_load_failure_action(err));
    }
    dispatch(load_po_from_backend());
  } catch (error) {
    const err = getErrorMessage(error);
    console.log({ err });
    dispatch(po_edit_failure_action(err));
  }
};

export const handle_po_date_update = (state, e, excel_row, key_name, id) => async (dispatch) => {
  dispatch(po_load_start_action());
  try {
    const temp = { ...state };
    const temp_arr = JSON.parse(JSON.stringify(temp.po.table_data)).map(data => {
      if (data.order === id) {
        console.log("updating", data);
        data[key_name] = convert_date_to_dd_mm_yyyy(new Date(e.$d));
      }
      return { ...data };
    });
    temp.po.table_data = temp_arr;
    const payload = {
      ...temp.po,
    };
    try {
      // console.log(new Date(e.$d));
      const patch_body = {
        // order: id,
        batch_no: id,
        // [key_name]: convert_date_to_dd_mm_yyyy(new Date(e.$d))
        [key_name]: new Date(e.$d)
      };
      const response = await PO_Backlog_Service.po_data_patch(patch_body);
      const result = response.data;
      if (result.data) {
        dispatch(po_edit_success_action(payload));
      }
    } catch (error) {
      const err = getErrorMessage(error);
      dispatch(po_load_failure_action(err));
    }
    dispatch(load_po_from_backend());
  } catch (error) {
    const error_message = getErrorMessage(error);
    dispatch(po_edit_failure_action(error_message));
  }
  // set_backlog_object((prev) => {
  //   const temp = { ...prev };
  //   return temp;
  // });
};
